export default __webpack_public_path__ + "static/media/18.0bd464e0.jpg";